var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLine)?_c('LineIndex',{attrs:{"selected-page":_vm.page,"line-id":_vm.elementId}},[_c('div')]):_c('Machine',{attrs:{"element-id":_vm.elementId,"selected-page":_vm.page}},[_c('div')]),_c('RouterView',{on:{"pageChange":function($event){_vm.page = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }